import React from 'react';

import { useAIAnswerContext } from '../ai-answer-dialog/ai-answer-context';
import { QueryIntent } from '../constants';

import { PersonKnowledgeCard } from './person-knowledge-card';
import { TeamKnowledgeCard } from './team-knowledge-card';

export const KnowledgeCard = () => {
	const { isAnswered, hasError, smartAnswersRoute } = useAIAnswerContext();

	if (isAnswered && !hasError) {
		switch (smartAnswersRoute) {
			case QueryIntent.TEAM:
				return <TeamKnowledgeCard />;
			case QueryIntent.PERSON:
				return <PersonKnowledgeCard />;
			default:
				return null;
		}
	}

	return null;
};
